var _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserManagerIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.72,371.66c-31.79-6.47-125.89-22.39-125.89-97.14,0-77.91,55.28-97.6,130.31-97.6,70.07,0,52.35-77,147.12-77,80.24,0,136.52,121,38.06,219.47C315.55,379.15,221.66,379,185.72,371.66Z",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.72,371.66c-31.79-6.47-125.89-22.39-125.89-97.14,0-77.91,55.28-97.6,130.31-97.6,70.07,0,52.35-77,147.12-77,80.24,0,136.52,121,38.06,219.47C315.55,379.15,221.66,379,185.72,371.66Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-13"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-13",
    cx: 245.18,
    cy: 412.39,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Settings--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.19,383.4H225.5a14.64,14.64,0,0,1-14.76-15.58l13.6-259.54a16.61,16.61,0,0,1,16.4-15.58H345.42a14.64,14.64,0,0,1,14.77,15.58l-13.6,259.54A16.62,16.62,0,0,1,330.19,383.4Z",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.88,103.15H240.19a10.55,10.55,0,0,0-10.4,9.88l-13.1,250a9.28,9.28,0,0,0,9.36,9.88H330.74a10.55,10.55,0,0,0,10.4-9.88l13.1-250A9.28,9.28,0,0,0,344.88,103.15Z",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.88,103.15H240.19a10.55,10.55,0,0,0-10.4,9.88l-13.1,250a9.28,9.28,0,0,0,9.36,9.88H330.74a10.55,10.55,0,0,0,10.4-9.88l13.1-250A9.28,9.28,0,0,0,344.88,103.15Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354,92.7h-8.55a14.64,14.64,0,0,1,14.77,15.58l-13.6,259.54a16.61,16.61,0,0,1-16.4,15.58h8.55a16.61,16.61,0,0,0,16.4-15.58l13.6-259.54A14.64,14.64,0,0,0,354,92.7Z",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354,92.7h-8.55a14.64,14.64,0,0,1,14.77,15.58l-13.6,259.54a16.61,16.61,0,0,1-16.4,15.58h8.55a16.61,16.61,0,0,0,16.4-15.58l13.6-259.54A14.64,14.64,0,0,0,354,92.7Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.18,103.15,254.4,373h37l-14.22-269.8H240.18Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.1 372.95 306.43 372.95 292.21 103.15 283.88 103.15 298.1 372.95",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.46,88.15h3.67a.45.45,0,0,0,0-.9h-3.67a.45.45,0,0,0,0,.9Z",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.78,117.77c.23-4.28.05-8.85,1-13,2.12-9.64,10.78-16.24,20.48-16.57.57,0,.58-.92,0-.9a22.46,22.46,0,0,0-20,13.26c-2.36,5.35-2,11.54-2.32,17.26,0,.58.87.58.9,0Z",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.78,156.7h-24a7.67,7.67,0,0,1-7.74-8.16l1.26-24a8.69,8.69,0,0,1,8.59-8.16h24a7.66,7.66,0,0,1,7.73,8.16l-1.25,24A8.71,8.71,0,0,1,300.78,156.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.46,140.16a10.8,10.8,0,0,1-2.81-6.7h-.1c-1,0-1.7-1.07-1.63-2.38s.91-2.38,1.88-2.38l.25,0,.18-.64c5.79-.31,9-2.22,10.77-3.78a6.14,6.14,0,0,0,3.8,3.27c.09.37.17.76.23,1.15l.25,0c1,0,1.71,1.06,1.64,2.38s-.92,2.38-1.89,2.38h-.1a12.27,12.27,0,0,1-3.19,6.39,10.38,10.38,0,0,0,4.24.43c5.85-.34,2.76-12.37-.39-16.68-1.92-2.64-3-3.87-4.09-3.38-1.22-.67-8.55-3.69-13.29,5.2C276.29,134.65,274.83,143.05,285.46,140.16Z",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.57,146.63l-6.05-1.93s-5.23,2-6.48,7c-.72-5-5.74-7-5.74-7l-6.25,1.93c-3.75.52-5.57,3.73-6.45,7.05a7.69,7.69,0,0,0,6.18,3h24a8.63,8.63,0,0,0,6.5-3C306.75,150.36,305.26,147.15,301.57,146.63Z",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.15,153.17a9.53,9.53,0,0,0,0-1.42l2.39-2.06a12.21,12.21,0,0,0-1-2.86l-3.07.16a9.53,9.53,0,0,0-1.9-2l.32-3.06a12.2,12.2,0,0,0-2.8-1.18L309.85,143a10.88,10.88,0,0,0-1.41-.1,11.19,11.19,0,0,0-1.43.1l-1.93-2.27a13.33,13.33,0,0,0-2.92,1.18V145a11.17,11.17,0,0,0-2.11,2l-3.05-.16a14.08,14.08,0,0,0-1.34,2.86l2.17,2.06a9.34,9.34,0,0,0-.17,1.42,9.44,9.44,0,0,0,0,1.41l-2.38,2.06a12.66,12.66,0,0,0,1,2.86l3.07-.16a10.07,10.07,0,0,0,1.9,2l-.31,3.06a12.12,12.12,0,0,0,2.79,1.18l2.18-2.27a10.88,10.88,0,0,0,1.41.1,11,11,0,0,0,1.42-.1l1.94,2.27a13.74,13.74,0,0,0,2.92-1.18v-3.06a11.81,11.81,0,0,0,2.11-2l3.05.16a13.53,13.53,0,0,0,1.33-2.86L318,154.58A10.86,10.86,0,0,0,318.15,153.17Zm-10.42,3.21a3,3,0,0,1-3.05-3.21,3.44,3.44,0,0,1,3.39-3.22,3,3,0,0,1,3,3.22A3.42,3.42,0,0,1,307.73,156.38Z",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.15,153.17a9.53,9.53,0,0,0,0-1.42l2.39-2.06a12.21,12.21,0,0,0-1-2.86l-3.07.16a9.53,9.53,0,0,0-1.9-2l.32-3.06a12.2,12.2,0,0,0-2.8-1.18L309.85,143a10.88,10.88,0,0,0-1.41-.1,11.19,11.19,0,0,0-1.43.1l-1.93-2.27a13.33,13.33,0,0,0-2.92,1.18V145a11.17,11.17,0,0,0-2.11,2l-3.05-.16a14.08,14.08,0,0,0-1.34,2.86l2.17,2.06a9.34,9.34,0,0,0-.17,1.42,9.44,9.44,0,0,0,0,1.41l-2.38,2.06a12.66,12.66,0,0,0,1,2.86l3.07-.16a10.07,10.07,0,0,0,1.9,2l-.31,3.06a12.12,12.12,0,0,0,2.79,1.18l2.18-2.27a10.88,10.88,0,0,0,1.41.1,11,11,0,0,0,1.42-.1l1.94,2.27a13.74,13.74,0,0,0,2.92-1.18v-3.06a11.81,11.81,0,0,0,2.11-2l3.05.16a13.53,13.53,0,0,0,1.33-2.86L318,154.58A10.86,10.86,0,0,0,318.15,153.17Zm-10.42,3.21a3,3,0,0,1-3.05-3.21,3.44,3.44,0,0,1,3.39-3.22,3,3,0,0,1,3,3.22A3.42,3.42,0,0,1,307.73,156.38Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.73,156.38a3,3,0,0,1-3.05-3.21,3.44,3.44,0,0,1,3.39-3.22,3,3,0,0,1,3,3.22A3.42,3.42,0,0,1,307.73,156.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.11 267.37 283.7 267.37 284.01 261.51 287.41 261.51 287.11 267.37",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.62 267.37 299.22 267.37 299.73 257.71 303.13 257.71 302.62 267.37",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.14 267.37 314.74 267.37 315.44 253.91 318.85 253.91 318.14 267.37",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.66 267.37 330.25 267.37 331.16 250.12 334.56 250.12 333.66 267.37",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.08,267.37h17.3a9.22,9.22,0,0,0,9.11-8.65,8.13,8.13,0,0,0-8.2-8.65H241a9.22,9.22,0,0,0-9.11,8.65A8.13,8.13,0,0,0,240.08,267.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.89,252h17.3a8.12,8.12,0,0,1,8.2,7.7c.05-.31.08-.63.1-.95a8.13,8.13,0,0,0-8.2-8.65H241a9.22,9.22,0,0,0-9.11,8.65c0,.32,0,.64,0,.95A9.25,9.25,0,0,1,240.89,252Z",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.89,252h17.3a8.12,8.12,0,0,1,8.2,7.7c.05-.31.08-.63.1-.95a8.13,8.13,0,0,0-8.2-8.65H241a9.22,9.22,0,0,0-9.11,8.65c0,.32,0,.64,0,.95A9.25,9.25,0,0,1,240.89,252Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.53,
    cy: 258.72,
    rx: 8.88,
    ry: 8.43,
    transform: "translate(-112.3 241.28) rotate(-44.26)",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.33 341.94 226.93 341.94 227.34 334.18 230.74 334.18 230.33 341.94",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.95 340.04 239.55 340.04 239.71 337.03 243.11 337.03 242.95 340.04",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.42 340.99 252.02 340.99 252.27 336.08 255.68 336.08 255.42 340.99",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.99 340.04 264.58 340.04 264.74 337.03 268.15 337.03 267.99 340.04",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.41 341.94 277 341.94 277.41 334.18 280.81 334.18 280.41 341.94",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.02 340.04 289.62 340.04 289.78 337.03 293.18 337.03 293.02 340.04",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.49 340.99 302.09 340.99 302.35 336.08 305.75 336.08 305.49 340.99",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.06 340.04 314.66 340.04 314.81 337.03 318.22 337.03 318.06 340.04",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.48 341.94 327.08 341.94 327.48 334.18 330.89 334.18 330.48 341.94",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "230.33 341.94 226.93 341.94 227.34 334.18 230.74 334.18 230.33 341.94"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "242.95 340.04 239.55 340.04 239.71 337.03 243.11 337.03 242.95 340.04"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "255.42 340.99 252.02 340.99 252.27 336.08 255.68 336.08 255.42 340.99"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "267.99 340.04 264.58 340.04 264.74 337.03 268.15 337.03 267.99 340.04"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "280.41 341.94 277 341.94 277.41 334.18 280.81 334.18 280.41 341.94"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "293.02 340.04 289.62 340.04 289.78 337.03 293.18 337.03 293.02 340.04"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "305.49 340.99 302.09 340.99 302.35 336.08 305.75 336.08 305.49 340.99"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "318.06 340.04 314.66 340.04 314.81 337.03 318.22 337.03 318.06 340.04"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "330.48 341.94 327.08 341.94 327.48 334.18 330.89 334.18 330.48 341.94"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M270.8,343.22c.05-.86.2-3.83.25-4.68s.2-3.83.24-4.68a4.4,4.4,0,0,0-4.43-4.69,5,5,0,0,0-4.93,4.69c-.05.85-.2,3.82-.25,4.68s-.2,3.82-.24,4.68a4.4,4.4,0,0,0,4.43,4.68A5,5,0,0,0,270.8,343.22Z",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.89,309.07H255.2a9.21,9.21,0,0,0,9.1-8.65,8.12,8.12,0,0,0-8.19-8.65H238.8a9.22,9.22,0,0,0-9.11,8.65A8.13,8.13,0,0,0,237.89,309.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.7,293.67H256a8.11,8.11,0,0,1,8.19,7.7,7.46,7.46,0,0,0,.1-.95,8.12,8.12,0,0,0-8.19-8.65H238.8a9.22,9.22,0,0,0-9.11,8.65c0,.32,0,.64,0,.95A9.23,9.23,0,0,1,238.7,293.67Z",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.7,293.67H256a8.11,8.11,0,0,1,8.19,7.7,7.46,7.46,0,0,0,.1-.95,8.12,8.12,0,0,0-8.19-8.65H238.8a9.22,9.22,0,0,0-9.11,8.65c0,.32,0,.64,0,.95A9.23,9.23,0,0,1,238.7,293.67Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,300.42a9.22,9.22,0,0,1,9.11-8.65,8.12,8.12,0,0,1,8.19,8.65,9.21,9.21,0,0,1-9.1,8.65A8.13,8.13,0,0,1,247,300.42Z",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.59,188H334a4.9,4.9,0,0,0,4.84-4.59,4.32,4.32,0,0,0-4.35-4.59H240.07a4.89,4.89,0,0,0-4.83,4.59A4.3,4.3,0,0,0,239.59,188Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.07,180.85h94.37a4.29,4.29,0,0,1,4.23,3.38,6.84,6.84,0,0,0,.12-.79,4.32,4.32,0,0,0-4.35-4.59H240.07a4.89,4.89,0,0,0-4.83,4.59,4.08,4.08,0,0,0,.12,1.22A4.89,4.89,0,0,1,240.07,180.85Z",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.07,180.85h94.37a4.29,4.29,0,0,1,4.23,3.38,6.84,6.84,0,0,0,.12-.79,4.32,4.32,0,0,0-4.35-4.59H240.07a4.89,4.89,0,0,0-4.83,4.59,4.08,4.08,0,0,0,.12,1.22A4.89,4.89,0,0,1,240.07,180.85Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 256.85,
    cy: 183.44,
    rx: 8.88,
    ry: 8.43,
    transform: "translate(-55.14 231.25) rotate(-44.25)",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.35,295.1a3.13,3.13,0,0,0-3.16-3.33H301.33a3.56,3.56,0,0,0-3.51,3.33l-.56,10.64a3.13,3.13,0,0,0,3.16,3.33h27.86a3.56,3.56,0,0,0,3.51-3.33Z",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.23,293.67h27.86a3.13,3.13,0,0,1,3.16,3.33l.1-1.9a3.13,3.13,0,0,0-3.16-3.33H301.33a3.56,3.56,0,0,0-3.51,3.33l-.1,1.9A3.56,3.56,0,0,1,301.23,293.67Z",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.23,293.67h27.86a3.13,3.13,0,0,1,3.16,3.33l.1-1.9a3.13,3.13,0,0,0-3.16-3.33H301.33a3.56,3.56,0,0,0-3.51,3.33l-.1,1.9A3.56,3.56,0,0,1,301.23,293.67Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.13,295.1a3.13,3.13,0,0,0-3.16-3.33H301.33a3.56,3.56,0,0,0-3.51,3.33l-.56,10.64a3.13,3.13,0,0,0,3.16,3.33h10.64a3.56,3.56,0,0,0,3.51-3.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.74 303.35 304.34 303.35 304.65 297.49 308.05 297.49 307.74 303.35",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.46,216.49H238.1a4.91,4.91,0,0,0-4.84,4.59,4.31,4.31,0,0,0,4.35,4.59H332a4.88,4.88,0,0,0,4.83-4.59A4.31,4.31,0,0,0,332.46,216.49Z",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.1,218.49h94.36a4.28,4.28,0,0,1,4.23,3.37,4,4,0,0,0,.12-.78,4.31,4.31,0,0,0-4.35-4.59H238.1a4.74,4.74,0,0,0-4.72,5.81A4.91,4.91,0,0,1,238.1,218.49Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.82,229.73h-7.23a4.74,4.74,0,0,1-4.78-5l.38-7.23a5.37,5.37,0,0,1,5.31-5h7.23a4.73,4.73,0,0,1,4.77,5l-.38,7.23A5.37,5.37,0,0,1,317.82,229.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.58 224.01 313.18 224.01 313.49 218.15 316.89 218.15 316.58 224.01",
    style: {
      fill: "#48A42C"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.81,190.56,155,205.06c1,6.92,3.09,27,3.09,27-1.92,2.54-6.61,1.82-6.61,1.82a66.53,66.53,0,0,1-4.58-30.08c.9-9.37,12.92-27.8,21.48-33a16.76,16.76,0,0,1,4.49-1.89l1.69-.2-6,22.29Z",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.81,190.56,155,205.06c1,6.92,3.09,27,3.09,27-1.92,2.54-6.61,1.82-6.61,1.82a66.53,66.53,0,0,1-4.58-30.08c.9-9.37,12.92-27.8,21.48-33a16.76,16.76,0,0,1,4.49-1.89l1.69-.2-6,22.29Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.39,233.64l3.1,3.31a1.14,1.14,0,0,1,.23.38l1.82,5.12a1.11,1.11,0,0,1,0,.84l-.88,1.81a1.08,1.08,0,0,1-.76.59L154.57,247a1.09,1.09,0,0,1-1.29-.87l-1.22-6.74a1,1,0,0,1,0-.41l.84-4.32a1.09,1.09,0,0,1,.88-.86l2.63-.47A1.09,1.09,0,0,1,157.39,233.64Z",
    style: {
      fill: "#fab27b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.06 232.88 150.2 237.35 150.07 232.58 159.17 229.08 160.06 232.88",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.06 232.88 150.2 237.35 150.07 232.58 159.17 229.08 160.06 232.88",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.24,250.52c-5.88,21-3.39,52-6.62,72.79-2.22,14.32-17.4,61.45-17.4,61.45l13.4,4.06s16.72-41.51,20-53.88c5.26-20.07,13.16-58.15,13.16-58.15s2.95-10.8,1.61-12S156.24,250.52,156.24,250.52Z",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,264.94l9.69,3.14-3.63,17S178.84,268.82,171,264.94Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.91 384.15 132.51 391.76 139.01 394.68 142.23 386.6 134.91 384.15",
    style: {
      fill: "#fab27b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.49 388.66 140.35 391.31 141.26 389.02 134.05 386.89 133.49 388.66",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.36 380.59 148.75 385.07 145.78 390.35 131.44 386.12 132.36 380.59",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.36 380.59 148.75 385.07 145.78 390.35 131.44 386.12 132.36 380.59",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.4,395.72a.22.22,0,0,1-.09-.21.19.19,0,0,1,.16-.15c.15,0,3.41-.5,4.55.35a1,1,0,0,1,.41.65.73.73,0,0,1-.3.79,3.53,3.53,0,0,1-2.47-.3A14.45,14.45,0,0,1,140.4,395.72Zm.68,0c1.36.74,3.29,1.48,3.84,1.12.08,0,.17-.13.12-.41a.51.51,0,0,0-.26-.39,1.14,1.14,0,0,0-.32-.18A8.94,8.94,0,0,0,141.08,395.7Z",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.31,395.67a.2.2,0,0,1,0-.2c.05-.09,1.06-2.07,2.35-2.49a1.44,1.44,0,0,1,1.13.08c.48.25.54.56.47.78-.17.92-2.66,1.86-3.73,1.91a.11.11,0,0,1-.08,0A.17.17,0,0,1,140.31,395.67Zm3.2-2.31a1,1,0,0,0-.71,0,4.62,4.62,0,0,0-1.94,2c1.17-.19,2.89-1,3-1.55,0-.05,0-.19-.28-.35l-.11,0Z",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,394.34l-8.35-3.27a.72.72,0,0,0-.87.26l-4.17,6.21a1.21,1.21,0,0,0,.31,1.67l.23.12c3,1.12,5.77,2,9.52,3.48,4.42,1.74,3.09,1.83,8.26,3.94,3.12,1.27,5.09-2.07,3.83-2.76-5.78-3.15-5.69-5.24-7.19-8.33A2.84,2.84,0,0,0,140,394.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.48 390.35 194.63 397.68 201.72 398.36 202.15 390.35 194.48 390.35",
    style: {
      fill: "#fab27b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.97 393.75 202.07 391.83 194.52 392.14 194.57 394.38 201.97 393.75",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.24,250.52c2.22-10.58,11.08-20,11.08-20l34,2.18s2.14,21.84,2.64,29.14c1,14.74,5.14,37.63,5.25,52.41.15,20-4.43,73.07-4.43,73.07l-12.84,1.52s.19-49.09-1.91-67.6c-1.59-14-11.17-52.46-11.17-52.46S152.53,268.26,156.24,250.52Z",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.72 386.77 206.68 385.73 205.57 391.68 190.63 392.3 189.72 386.77",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.72 386.77 206.68 385.73 205.57 391.68 190.63 392.3 189.72 386.77",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.26,398.87a.2.2,0,0,1-.15-.17.17.17,0,0,1,.1-.19c.13-.07,3.06-1.6,4.41-1.16a1,1,0,0,1,.6.47.75.75,0,0,1,0,.85,3.49,3.49,0,0,1-2.44.53A15,15,0,0,1,203.26,398.87Zm.64-.24c1.52.25,3.59.32,4-.2.06-.06.11-.18,0-.42a.52.52,0,0,0-.37-.29,1.19,1.19,0,0,0-.37-.06A8.9,8.9,0,0,0,203.9,398.63Z",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.15,398.85a.23.23,0,0,1-.08-.18c0-.1.33-2.3,1.41-3.12a1.42,1.42,0,0,1,1.09-.29c.53.07.69.35.7.57.14.93-1.9,2.64-2.9,3a.08.08,0,0,1-.08,0A.18.18,0,0,1,203.15,398.85Zm2.28-3.23a1.07,1.07,0,0,0-.69.22,4.62,4.62,0,0,0-1.19,2.47c1-.56,2.4-1.9,2.37-2.46,0-.05,0-.19-.38-.23Z",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.46,397.69l-9-.36a.73.73,0,0,0-.73.54l-1.91,7.23a1.2,1.2,0,0,0,.85,1.47,1,1,0,0,0,.25,0c3.23.07,6.11,0,10.14.17,4.74.19,3.52.71,9.1,1,3.36.18,4.12-3.62,2.71-3.86-6.5-1.08-7.1-3.08-9.52-5.51A2.91,2.91,0,0,0,202.46,397.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.83,160.28c-.59,1.89-2.07,5.08,0,7.93l-10.21-1s1.09-7.53,1.72-10c.41-1.59.94-3.32,6.31-1.82C192.73,156.28,192.23,159,191.83,160.28Z",
    style: {
      fill: "#fab27b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.62,157.49c-5.62-4.34-17.5-16.1-6.1-26.37,9.49-8.55,18.21-3.55,21.18,2.23,3.33,6.47,10.88,23.76-5.87,26.93C188.75,160.86,185.54,159.74,182.62,157.49Z",
    style: {
      fill: "#fab27b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.59,167.55s7.88-6.92,22.85,2.21l-.21,2.14-22.5-2.18Z",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.59,167.55s7.88-6.92,22.85,2.21l-.21,2.14-22.5-2.18Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.68,158.24c0,2.31.71,3.51,1.54,4.11a15.26,15.26,0,0,1,.61-2.07C189.82,159.4,189.68,158.24,189.68,158.24Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.68,169.49a94.36,94.36,0,0,0-9.81-1.56c-5.8-.68-10.23-1.13-13.43.28-5.1,2.25-5.75,3.69-5.75,3.69l1,16.53a147.43,147.43,0,0,1,.43,24c0,.07-.4,15.75-8.87,24.17a27.67,27.67,0,0,0,12.14,5.67l4.78-11.44,1.51,12s17.21,5.1,31.41.39c0,0-7.77-12.42-5.27-25.12,1.21-6.11,2.09-9,2.77-13.8a26.07,26.07,0,0,0,0-7.81l-3.19-21.8S197.76,170,195.68,169.49Z",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.68,169.49a94.36,94.36,0,0,0-9.81-1.56c-5.8-.68-10.23-1.13-13.43.28-5.1,2.25-5.75,3.69-5.75,3.69l1,16.53a147.43,147.43,0,0,1,.43,24c0,.07-.4,15.75-8.87,24.17a27.67,27.67,0,0,0,12.14,5.67l4.78-11.44,1.51,12s17.21,5.1,31.41.39c0,0-7.77-12.42-5.27-25.12,1.21-6.11,2.09-9,2.77-13.8a26.07,26.07,0,0,0,0-7.81l-3.19-21.8S197.76,170,195.68,169.49Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M205.57,210.49c.41-2.21.77-4.29,1-6.14a26.07,26.07,0,0,0,0-7.81l-4.57-5.14S206.4,197.58,205.57,210.49Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M246.38,187l3.16-9a.74.74,0,0,1,.36-.42l4.95-2.53a.77.77,0,0,1,.83.11l3.53,3.1a.74.74,0,0,1,.1,1l-3.65,4.8a.77.77,0,0,0-.1.18c-.28.71-2.16,5.2-6.16,6.32l-.15.06-1.34.71a.74.74,0,0,1-1-.22l-1.71-2.39a.74.74,0,0,1,.3-1.11l.45-.21A.69.69,0,0,0,246.38,187Z",
    style: {
      fill: "#fab27b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.59,169.48a25.56,25.56,0,0,1,14.79,10.12,102.72,102.72,0,0,0,15,15.33s11.56-2.46,18.85-8.77l4.28,6.39s-17.56,13.24-24.71,12.55c-6.1-.59-17.22-8.53-17.22-8.53L202,191.43Z",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.59,169.48a25.56,25.56,0,0,1,14.79,10.12,102.72,102.72,0,0,0,15,15.33s11.56-2.46,18.85-8.77l4.28,6.39s-17.56,13.24-24.71,12.55c-6.1-.59-17.22-8.53-17.22-8.53L202,191.43Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.63 185.36 251.05 193.33 246.75 194.47 241.63 186.98 244.63 185.36",
    style: {
      fill: "#48A42C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.63 185.36 251.05 193.33 246.75 194.47 241.63 186.98 244.63 185.36",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.87 147.17 201.87 150.27 203.96 149.98 201.87 147.17",
    style: {
      fill: "#e07f50"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M185.48,165.73c-4.81.49-19,.77-17.31-9.64s-.61-15.57,3.8-22.9,13.6-9.47,21.87-7.3c6.89,1.8,7.45,6.62,5.58,9.52s-2.71,3.44-2.38,5.5-.92,3.21-1.46,4.18a5.71,5.71,0,0,1-2.2,1.59,12.66,12.66,0,0,0,.37,6.07C194.75,156.56,196.79,164.56,185.48,165.73Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M191.88,126a19.71,19.71,0,0,1,6.65,1.91c1.63.84,3.26,2.09,3.63,4,.53,2.75-1.6,5.36-3.29,7.26-.27.31.25.67.51.37,3-3.36,5.32-8.08.92-11.3a17.75,17.75,0,0,0-8.36-2.86.31.31,0,0,0-.06.62Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M172,133.13c-3.17,4.11-3.32,9.48-4,14.38-.45,3.46-4.35,10.21-1.59,13.47.26.31.76-.08.5-.39-1.89-2.23,0-5.51.64-7.82a41.57,41.57,0,0,0,1.23-6.93c.43-4.19,1-8.87,3.69-12.33.25-.32-.26-.7-.51-.38Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M199.72,141.27c-.06.13.05-.1.07-.13a1.5,1.5,0,0,1,.23-.33,1.08,1.08,0,0,1,1.16-.34c.38.09.54-.49.16-.58a1.85,1.85,0,0,0-2.2,1.22c-.15.35.43.51.58.16Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M197.26,145.83c.64,1.92,0,3.86-1.37,4.33s-3-.71-3.7-2.64,0-3.86,1.37-4.33S196.61,143.9,197.26,145.83Z",
    style: {
      fill: "#fab27b"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M202,141c-.09.72-.79.87-1.15.93s-.39.47-.32,1,.32.91.56.87.39-.47.33-1a2.1,2.1,0,0,0-.12-.42C202.43,141.7,202,141,202,141Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserManagerIllustration);
export default __webpack_public_path__ + "static/media/user-manager_illustration.c5540a78b7068838a61128e3024aac3b.svg";
export { ForwardRef as ReactComponent };